import { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Icon = ({ label, className = '', ...args }) => (
  <i {...args} className={classNames(`icon-${label}`, className)} />
);

Icon.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default memo(Icon);
